require('./nerudaUserCardsView.scss');

// @vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const { connect } = require('react-redux');
import { withRouter } from 'react-router-dom';

// @actions
const aggregatorDataActions = require('actions/aggregator/aggregatorData');
const cardTravelActions = require('actions/cardTravel');
const commercialAdsAction = require('actions/commercialInterstitialsAds');
const expensesActionsOld = require('actions/globalPositionExpensesOld');
const hireCardRevolvingActions = require('actions/hireCardRevolving');
const landingActions = require('actions/landings');

// @core
const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
const { OKMessage } = require("commonsComponents/OKMessage");
const { EmptyState } = require('commonsComponents/emptyState');
const { isAggregatorEnabled } = require('utilities/aggregator/aggregatorToggleHelper');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const LastAccess = !__CONTACT_CENTER__
    ? require('components/lastAccess/lastAccess')
    : require('components/contactCenter/lastAccesContactCenter/lastAccesContactCenter');

// @components
const AggregatorResume = require('components/aggregator/aggregatorResume/aggregatorResume');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const { ECommerceKeyBanner } = require('components/eCommerceKeyBanner/eCommerceKeyBanner');
const { CardsBox } = require('components/cards/cardsBox/cardsBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const GlobalPositionExpenses = require('components/globalPosition/globalPositionExpenses/globalPositionExpenses');
const ExpensesSummaryBox = require('components/expensesSummaryBox/expensesSummaryBox');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const WebappRender = require('components/conditionalRender/webappRender');

// @helpers
const { getCommercialCardsList } = require('utilities/commercialAdsHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { existCancelledCards } = require('utilities/contactCenter/cancelledCardsHelper');
const { contactCenterClassName, conditionalClassName } = require('utilities/conditionals/conditionalClassname');

// @constants
const { GRAPHIC_TUTOR_TYPE_6 } = require('constants/index');
const { INACTIVE_STATUS_LIST, CANCELLED_STATUS } = require('constants/contactCenter/cardStatus');
const {
    AGGREGATOR,
    CREDIT,
    ECOMMERCE_KEY,
    PFM,
    PFM_NEW_FEATURES,
    SCA_BANNER,
    TRAVEL_PLUS_R42,
} = require('constants/flagBasedFeatures');

class NerudaUserCardsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            scaMessageVisible: true
        };

        this.handleCloseSCAMessage = this.handleCloseSCAMessage.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.buildCards = this.buildCards.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
        this.handleCardsBoxClick = this.handleCardsBoxClick.bind(this);
        this.addMessageEventListener = this.addMessageEventListener.bind(this);
        this.scaMessage = null;
        this.linksAddedScaMessage = false;
    }

    componentDidMount() {
        const {
            flagBasedFeatures,
            getEntitiesData,
            immCards,
            immProfile,
            requestAds,
            setCardTravelPlus,
        } = this.props;

        const commercialCardsList = getCommercialCardsList(immCards, flagBasedFeatures, immProfile);

        if (flagBasedFeatures.get("hasBeenFetched") &&
            !flagBasedFeatures.get("hasError") &&
            flagBasedFeatures.get(AGGREGATOR) &&
            !__CONTACT_CENTER__) {
            getEntitiesData();
        }

        if (flagBasedFeatures.get(TRAVEL_PLUS_R42) && immCards.get('cardNumbersTravelPlus').size > 0) {
            setCardTravelPlus();
        }

        if (!this.linksAddedScaMessage && this.scaMessage) {
            this.addMessageEventListener(this.scaMessage);
            this.linksAddedScaMessage = true;
        }

        requestAds(commercialCardsList, 'allCards');
        scrollToTop();
    }

    addMessageEventListener(message) {
        const links = message.querySelectorAll("a");

        for (let i = 0; i < links.length; i++) {
            const link = links[i];
            const url = link.getAttribute("href");
            link.addEventListener("click", e => {
                e.preventDefault();
                this.props.history.push(url);
            });
        }
    }

    handleCloseSCAMessage = () => {
        this.setState({ scaMessageVisible: false });
    }

    buildSCAMessage = () => {
        const { flagBasedFeatures } = this.props;
        const { scaMessageVisible } = this.state;
        const showSCAMessage =
            flagBasedFeatures.get(SCA_BANNER) &&
            flagBasedFeatures.get(ECOMMERCE_KEY) &&
            !__CONTACT_CENTER__;
        let scaMessage;

        if (showSCAMessage) {
            scaMessage = (
                <div className="col-xs-12 col-md-12">
                    <div
                        className="neruda-user-cards-view__sca-message"
                        ref={ref => (this.scaMessage = ref)}
                    >
                        <OKMessage
                            closeButton={true}
                            id="scaMessage"
                            key="scaMessage"
                            modifier="dark-bg"
                            onCloseButtonClick={this.handleCloseSCAMessage}
                            visible={scaMessageVisible}
                        >
                            <FormattedText value="globalPosition-globalPosition_scaMessage" />
                        </OKMessage>
                    </div>
                </div>
            );
        }

        return scaMessage;
    };


    buildCards() {
        const {
            immCards,
            immCardsTransactions,
            immCommercialAds,
            immLandingBoxes,
            immProfile,
        } = this.props;

        const immCardsList = immCards.get('byOrder');

        let sectionContent;

        if (!!immCards.get('error')) {
            sectionContent = this.buildConnectionError();
        } else if (immCards.get('byId').isEmpty()) {
            sectionContent = <div />;
        } else {
            sectionContent = immCardsList
                .filter(cardId => immCards.getIn(['byId', cardId, 'visibleinCards']))
                .map((cardId, cardIndex) => {
                    const immCardsById = immCards.get('byId');
                    const expanded = immLandingBoxes.includes(cardIndex);
                    return (
                        <CardsBox
                            cardIndex={cardIndex}
                            expanded={expanded}
                            immCard={immCardsById.get(cardId)}
                            immCardsTransactions={immCardsTransactions}
                            immCommercialAds={immCommercialAds}
                            immProfile={immProfile}
                            key={cardIndex}
                            onClick={this.handleCardsBoxClick}
                        />
                    );
                });
        }

        return (
            <div>
                {sectionContent}
            </div>
        );
    }

    buildCardsCC() {
        const {
            immCards,
            immCardsTransactions,
            immCommercialAds,
            immLandingBoxes,
        } = this.props;
        const immCardsList = immCards.get('byOrder');
        const cancelledView = this.isCancelledView();

        let sectionContent;
        let rightSection = [];
        let leftSection = [];

        if (!!immCards.get('error')) {
            sectionContent = this.buildConnectionError();
        } else if (immCards.get('byId').isEmpty()) {
            sectionContent = <div />;
        } else {
            sectionContent = immCardsList.filter(cardId => {
                return immCards.getIn(['byId', cardId, 'visibleinCards']);
            });

            sectionContent = sectionContent.filter((cardId) => {
                const immCard = immCards.getIn(['byId', cardId]);
                const cardStatus = immCard.get('cancelled') ? CANCELLED_STATUS : immCard.get('status');
                const isCancelledCard = INACTIVE_STATUS_LIST.includes(cardStatus);
                return cancelledView ? isCancelledCard : !isCancelledCard;
            });

            sectionContent = sectionContent.map((cardId, cardIndex) => {
                const immCardsById = immCards.get('byId');
                const expanded = immLandingBoxes.includes(cardId) ? true : immLandingBoxes.includes(cardIndex);

                const card = (
                    <CardsBox
                        cardIndex={cardIndex}
                        expanded={expanded}
                        immCard={immCardsById.get(cardId)}
                        immCardsTransactions={immCardsTransactions}
                        immCommercialAds={immCommercialAds}
                        key={cardIndex}
                        onClick={this.handleCardsBoxClick} />
                );

                (cardIndex % 2 == 0) ? leftSection.push(card) : rightSection.push(card);

                return card;
            });

        }

        return {
            sectionContent: (<section className="neruda-user-cards-view__cards">{sectionContent}</section>),
            rightSection: (<section className="neruda-user-cards-view__cards">{rightSection}</section>),
            leftSection: (<section className="neruda-user-cards-view__cards">{leftSection}</section>)
        };
    }

    buildConnectionError() {
        const lostConnectionFirstLine = formatText('cards-lostConnectionFirstLine');

        return (
            <OKSectionBox>
                <EmptyState primaryText={lostConnectionFirstLine} iconType="nointernet-banking"/>
                <div className="text-center">
                    <OKButton onClick={this.handleRetry}>
                        <FormattedText value="cards-retry" />
                    </OKButton>
                </div>
            </OKSectionBox>
        );
    }

    handleCardsBoxClick(isExpanded, accountId) {
        const { boxToggle } = this.props;
        boxToggle(isExpanded, accountId, 'cards');
    }

    handleRetry() {
        //TODO ADD LOGIC HERE.
    }

    handleGoToCancelledCards() {
        this.props.history.push('/myprofile/cards/cancelled');
    }

    handleGoToAccountsLanding() {
        this.props.history.push('/myprofile/accounts');
    }

    isCancelledView(){
        return window.location.pathname.includes("cancelled");
    }

    render() {
        const {
            flagBasedFeatures,
            getEntitiesData,
            getSecondFactorAuth,
            immAccounts,
            immAggregatorData,
            immCards,
            immGlobalPosition,
            immLastKeyChange,
            isFetchingUserTechnicalInfo,
            lastAccess,
        } = this.props;
        const cards = !__CONTACT_CENTER__ ? this.buildCards() : this.buildCardsCC();
        const scaMessage = this.buildSCAMessage();
        const title = formatText('landingHeader-cards');
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_6}
                title={formatText('tutorials-cardsTitle')}
            />
        );

        let cancelledCardsButton;
        if (__CONTACT_CENTER__ && !this.isCancelledView()){
            cancelledCardsButton = (
                <OKButton modifier={"primary"} onClick={() => this.handleGoToCancelledCards()} disabled={!existCancelledCards(immCards)}>
                    <FormattedText value="cards-seeCancelledCards" />
                </OKButton>
            );
        }

        const breadcrumbCancelledCards = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: formatText('cards-subtitleCancelledCards'),
                url: ''
            }
        ];

        const OKHeaderView = this.isCancelledView() ? (
            <OKCover size="medium" section="cards" customClass="col-xs-12">
                <OKHeaderSubPage
                    breadcrumbConfig={breadcrumbCancelledCards}
                    className="ok-header-landing--accounts"
                    finalTitle={formatText('landingHeader-cards')}
                    subtitleLeft={formatText('cards-subtitleCancelledCards')}
                    tutorial={tutorial}
                >
                </OKHeaderSubPage>
            </OKCover>
        ) : (
            <OKCover size="small" section="cards" customClass="col-xs-12">
                <OKHeaderLanding
                    inputClassName="ok-header-landing--cards"
                    title={title}
                    tutorial={tutorial}
                >
                    <LastAccess
                        isLoading={isFetchingUserTechnicalInfo}
                        lastAccess={lastAccess}
                        title={formatText('common-lastAccess')}
                    />
                    <ContactCenterRender>
                        <LastAccess
                            error={immLastKeyChange.get('errorReceived')}
                            isLastModificationText={true}
                            isLoading={isFetchingUserTechnicalInfo}
                            lastAccess={immLastKeyChange.getIn(['cmcContract', 'keyChange'])}
                            title={formatText('commons-lastKeyChange')}
                        />
                    </ContactCenterRender>
                    {cancelledCardsButton}
                </OKHeaderLanding>
            </OKCover>
        );

        const gridBodyClassName = contactCenterClassName('neruda-user-cards-view__body', 'grid-view__body');
        const leftColumnClassName = conditionalClassName('col-xs-12 col-md-8 col-lg-8', 'neruda-user-cards-view__left-column col-xs-6');
        const rightColumnClassName = conditionalClassName('col-xs-12 col-md-4 col-lg-4', 'neruda-user-cards-view__right-column col-xs-6');
        const gridViewClassName = conditionalClassName('grid-view--fix-cell-separation-bottom', 'grid-view--variable-cell-separation', 'col-xs-12 col-sm-6 col-md-12');
        const bodyClassNames = classNames('container-fluid', 'grid-view--content-position-positive');
        const expensesClass = classNames('col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation-bottom', {
            'my-global-position-view__expenses': !flagBasedFeatures.get(AGGREGATOR) && !flagBasedFeatures.get(CREDIT) && __CONTACT_CENTER__
        });

        const expensesComponent = flagBasedFeatures.get(PFM_NEW_FEATURES) ?
            <ExpensesSummaryBox immAccounts={immAccounts} /> :
            (<GlobalPositionExpenses
                immExpenses={immGlobalPosition.get('expenses')}
                actions={expensesActionsOld}
            />);

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        {OKHeaderView}
                    </div>
                </div>
                <div className={gridBodyClassName}>
                    <div className={bodyClassNames}>
                        <div className="row">
                            {scaMessage}
                            <div className={leftColumnClassName}>
                                <div className="row">
                                    <ContactCenterRender>
                                        {cards.leftSection}
                                    </ContactCenterRender>
                                    <WebappRender>
                                        <div className="col-xs-12">
                                            {cards}
                                        </div>
                                    </WebappRender>
                                    <FeatureTogglingRender notAllowedProductKey={AGGREGATOR} >
                                        {isAggregatorEnabled(flagBasedFeatures) &&
                                            <div className="col-xs-12 grid-view--fix-cell-separation">
                                                <WebappRender>
                                                    <AggregatorResume
                                                        flagBasedFeatures={flagBasedFeatures}
                                                        getSecondFactorAuth={getSecondFactorAuth}
                                                        immAggregatorData={immAggregatorData}
                                                        retryAction={() => getEntitiesData(false, 0, true)}
                                                    />
                                                </WebappRender>
                                            </div>
                                        }
                                    </FeatureTogglingRender>
                                </div>
                            </div>
                            <div className={rightColumnClassName}>
                                <div className="row">
                                    <ContactCenterRender>
                                        {cards.rightSection}
                                    </ContactCenterRender>
                                    <WebappRender>
                                        <div className={gridViewClassName}>
                                            <div className="neruda-user-cards-view__accounts-section">
                                                <div className="neruda-user-cards-view__accounts-section-title">
                                                    <FormattedText value="nerudaUserCards-nerudaUserCards_accountsSectionTitle" />
                                                </div>
                                                <div className="neruda-user-cards-view__accounts-section-text">
                                                    <FormattedText value="nerudaUserCards-nerudaUserCards_accountsSectionDescription" />
                                                </div>
                                                <div className="row neruda-user-cards-view__accounts-section-buttons">
                                                    <div className="col-xs-6">
                                                        <OKButton onClick={() => this.handleGoToAccountsLanding()}>
                                                            <FormattedText value="nerudaUserCards-nerudaUserCards_goToAccountsLanding" />
                                                        </OKButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <FeatureTogglingRender notAllowedProductKey={PFM} >
                                            <div className={expensesClass}>
                                                {expensesComponent}
                                            </div>
                                        </FeatureTogglingRender>
                                        <div className="col-xs-12 col-sm-6 col-md-12">
                                            <ECommerceKeyBanner />
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation-bottom">
                                            <CallMeBack isSmall={true} pageTitle={formatText('breadcrumb-cards')} />
                                        </div>
                                    </WebappRender>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

NerudaUserCardsView.propTypes = {
    boxToggle: PropTypes.func,
    children: PropTypes.any,
    expensesActionsOld: PropTypes.object,
    flagBasedFeatures: PropTypes.object.isRequired,
    getEntitiesData: PropTypes.func,
    getSecondFactorAuth: PropTypes.func,
    getScoring: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object,
    immAggregatorData: PropTypes.object,
    immCards: PropTypes.object.isRequired,
    immCardsTransactions: PropTypes.object.isRequired,
    immCommercialAds: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object,
    immHireCardRevolving: PropTypes.object.isRequired,
    immLandingBoxes: PropTypes.object,
    immLastKeyChange: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    isFetchingUserTechnicalInfo: PropTypes.bool.isRequired,
    lastAccess: PropTypes.string.isRequired,
    requestAds: PropTypes.func.isRequired,
    setCardTravelPlus: PropTypes.func.isRequired,
};

module.exports.constructor = NerudaUserCardsView;
module.exports.NerudaUserCardsView = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immAccounts: state.accounts,
        immAggregatorData: state.aggregatorData,
        immCards: state.cards,
        immCardsTransactions: state.cardsTransactions,
        immCommercialAds: state.commercialAds,
        immGlobalPosition: state.globalPosition,
        immHireCardRevolving: state.hireCardRevolving,
        immLandingBoxes: state.landings.get('expandedBoxes').get('cards'),
        immLastKeyChange: state.accessKeyChange,
        immProfile: state.profile,
        isFetchingUserTechnicalInfo: state.accessKeyChange.get('isFetching'),
        lastAccess: state.accessKeyChange.getIn(['cmcContract', 'lastAccess']),
    }),{
        boxToggle: landingActions.boxToggle,
        expensesActionsOld,
        getEntitiesData: aggregatorDataActions.getEntitiesData,
        getSecondFactorAuth: aggregatorDataActions.getSecondFactorAuth,
        getScoring: hireCardRevolvingActions.getScoring,
        requestAds: commercialAdsAction.requestAds,
        setCardTravelPlus: cardTravelActions.setCardTravelPlus,
    }
)(withRouter(NerudaUserCardsView));
